import { useMemo } from 'react'
import { aMapRef, useAtomValue } from '~/atoms'
import {
  DEFAULT_GOOGLE_CAMERA_ANIMATION_DURATION_MS,
  NextMapGlobalSearch,
} from '~/components'
import { useEmbed, useMapCardSizes, useMapEaseTo } from '~/hooks'
import { cn } from '~/utils'

export default function MapSearch({ className }: { className?: string }) {
  const currentMap = useAtomValue(aMapRef)
  const mapRef = useMemo(() => ({ current: currentMap }), [currentMap])
  const mapCardSizes = useMapCardSizes()
  const mapEaseTo = useMapEaseTo(mapRef as any)
  const { isEmbed } = useEmbed()

  if (isEmbed) {
    return null
  }

  return (
    <NextMapGlobalSearch
      className={cn('w-42 overflow-hidden rounded-md shadow-md', className)}
      onPlaceSelect={({ lat, lng, zoom }) => {
        mapEaseTo({
          zoom: 18,
          center: [lng, lat],
          padding: {
            left: mapCardSizes.list,
            top: 0,
            right: 0,
            bottom: 0,
          },
          duration: DEFAULT_GOOGLE_CAMERA_ANIMATION_DURATION_MS,
        })
      }}
    />
  )
}
